/** How long the indicator keeps showing a call that ended without reaching the customer. */
export const CALL_FAILED_HIDE_DELAY_MS = 10000;
